<template>
  <BreadCrumb PageTitle="Liste des bons de retour" />
  <ReturnListe />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ReturnListe from "@/components/Notes/Return/Zone/ReturnListe.vue";

export default defineComponent({
  name: "ReturnListePage",
  components: {
    BreadCrumb,
    ReturnListe,
  },
});
</script>